export const toggleDocumentAttribute = (attribute, value, remove, tag = 'html') => {
  if (typeof document === 'undefined') return;
  const element = tag === 'html' ? document.documentElement : document.getElementsByTagName(String(tag))[0];
  if (!element) return;
  const hasAttribute = element.getAttribute(attribute);
  if (remove && hasAttribute) element.removeAttribute(attribute);
  else if (!remove) element.setAttribute(attribute, value);
};
